import { useFormik } from "formik";
import * as Yup from "yup";

const useLoginForm = (handleSubmit, onClose) => {
  return useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Էլ․ Հասցեի անվավեր ձևաչափ")
        .required("Պարտադիր դաշտ (Էլ․ Հասցե)"),
      password: Yup.string()
        .min(6, "Ամենաքիչը 6 նիշ")
        .required("Պարտադիր դաշտ (Գաղտնաբառ)"),
    }),
    onSubmit: (values) => {
      handleSubmit(values.email, values.password).then(() => onClose());
    },
  });
};

export default useLoginForm;
